import React, { Component } from "react";
import PropTypes from "prop-types";
import { returnUserJWT } from "../../../../../../js/shared/utils";
import InputCreditCard from "../../../../../../shared/atoms/InputCreditCard";
import SelectForm from "../../../../../../shared/atoms/SelectForm";
import InputForm from "../../../../../../shared/atoms/InputForm";
import { Heading } from "@maxmilhas/hangar-components-atomic/public";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const yearsOptions = new Array(15).fill().map((it, idx) => {
	let year = idx + currentYear;
	return { value: year, label: year };
});
const monthOptions = [
	{ label: "Jan", value: 1 },
	{ label: "Fev", value: 2 },
	{ label: "Mar", value: 3 },
	{ label: "Abr", value: 4 },
	{ label: "Mai", value: 5 },
	{ label: "Jun", value: 6 },
	{ label: "Jul", value: 7 },
	{ label: "Ago", value: 8 },
	{ label: "Set", value: 9 },
	{ label: "Out", value: 10 },
	{ label: "Nov", value: 11 },
	{ label: "Dez", value: 12 }
];

class EditCreditCardDetails extends Component {
	constructor() {
		super();
		this.state = {
			cardCpf: "",
			cardNumber: "",
			holderName: "",
			expirationMonth: "",
			expirationYear: "",
			cvv: "",
			details: null,
			activeBrand: undefined,
			errors: {
				cardNumber: false,
				holderName: false,
				expirationMonth: false,
				expirationYear: false,
				cvv: false
			}
		};

		this.onChange = this.onChange.bind(this);
		this.checkAllFilled = this.checkAllFilled.bind(this);
	}

	checkAllFilled() {
		const { checkData } = this.props;
		const {
			cardCpf,
			cardNumber,
			holderName,
			expirationMonth,
			expirationYear,
			cvv,
			errors
		} = this.state;

		let fieldsIsCompleted =
			!!cardCpf.length &&
			!!cardNumber.length &&
			!!holderName.length &&
			!!expirationMonth.length &&
			!!expirationYear.length &&
			!!cvv.length &&
			!errors.cardNumber &&
			!errors.holderName &&
			!errors.expirationMonth &&
			!errors.expirationYear &&
			!errors.cvv;

		checkData("completedBoxCreditCardDetails", fieldsIsCompleted);
	}

	onChange(event, details = this.state.details) {
		const { name, value } = event.target;
		const { setData } = this.props;
		const { errors, expirationYear, expirationMonth } = this.state;
		let newValue = value;

		switch (name) {
			case "cvv":
				newValue = String(newValue).replace(/[^0-9.]/g, "");
				this.setState({
					details,
					[name]: newValue,
					errors: {
						...errors,
						[name]: !newValue.length || !details || details.code.size !== newValue.length
					}
				});
				setData({ [name]: newValue });
				break;
			case "cardNumber":
				newValue = String(newValue).replace(/[^0-9.]/g, "");
				this.setState({
					details,
					[name]: newValue,
					errors: {
						...errors,
						[name]: !this.state.activeBrand || !details || !details.lengths.find(l => l === newValue.length),
            cvv: !!this.state.cvv.length && !!details && details.code.size !== this.state.cvv.length
					}
				});
				setData({ [name]: newValue });
				break;
			case "expirationMonth":
				this.setState({
					[name]: value,
					errors: {
						...errors,
						[name]: !value.length || (currentYear == expirationYear && value < currentMonth)
					}
				});
				setData({ [name]: newValue });
				break;
			case "expirationYear":
				this.setState({
					[name]: value,
					errors: {
						...errors,
						expirationMonth:
							!value.length || (currentYear == value && expirationMonth < currentMonth)
					}
				});
				setData({ [name]: newValue });
				break;
			case "holderName":
				newValue = String(newValue).replace(/[0-9]/g, "");
				this.setState({
					[name]: newValue,
					errors: {
						...errors,
						[name]: !newValue.length
					}
				});
				setData({ [name]: newValue });
				break;
			default:
				this.setState({
					[name]: value,
					errors: {
						...errors,
						[name]: !value.length
					}
				});
				setData({ [name]: value });
				break;
		}

		setTimeout(() => this.checkAllFilled(), 200);
	}

	componentWillMount() {
		const { creditCardData, setData } = this.props;

		let user = returnUserJWT() || {};

		let cardCpf = user.ssn ? user.ssn : creditCardData.cpfcnpj;
		cardCpf = cardCpf.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
		let holderName = creditCardData.name ? creditCardData.name : "";
		let cardNumber = creditCardData.number
			? String(creditCardData.number).replace(/[^0-9.]/g, "")
			: "";
		let cvv = creditCardData.securityCode
			? creditCardData.securityCode.replace(/[^0-9.]/g, "")
			: "";
		let expirationMonth = creditCardData.validDate ? creditCardData.validDate.split("/")[0] : "";
		let expirationYear = creditCardData.validDate ? creditCardData.validDate.split("/")[1] : "";

		this.setState({
			cardCpf,
			holderName,
			cardNumber,
			cvv,
			expirationMonth,
			expirationYear
		});
		setData({ cardCpf: cardCpf });

		setTimeout(() => this.checkAllFilled(), 200);
	}

	render() {
		const {
			cardCpf,
			cardNumber,
			holderName,
			expirationMonth,
			expirationYear,
			cvv,
			details,
			errors
		} = this.state;

		return (
			<div className="edit-credit-card-details">
				<Heading tag="h6">Dados do cartão</Heading>
				<div className="row">
					<div className="col-xs-16 col-md-8">
						<InputCreditCard
							name="cardNumber"
							id="cardNumber"
							value={cardNumber}
							onChange={this.onChange}
							placeholder=""
							label="Número do cartão"
							errorMessage="Número inválido"
							maxLength={30}
							hasError={errors.cardNumber}
							data-action="register-credit-card-number"
							getActiveBrand={activeBrand => this.setState({ activeBrand })}
						/>
					</div>
					<div className="col-xs-8 col-md-4">
						<SelectForm
							name="expirationMonth"
							options={monthOptions}
							value={expirationMonth}
							onChange={this.onChange}
							defaultOption="Mês"
							label="Validade"
							errorMessage="Data inválida"
							hasError={errors.expirationMonth}
							data-action="register-credit-card-valid-month"
						/>
					</div>
					<div className="col-xs-8 col-md-4">
						<SelectForm
							name="expirationYear"
							options={yearsOptions}
							value={expirationYear}
							onChange={this.onChange}
							defaultOption="Ano"
							label={"\u00A0"}
							errorMessage={errors.expirationMonth ? "" : "Data inválida"}
							hasError={errors.expirationYear}
							data-action="register-credit-card-valid-year"
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-16 col-md-4">
						<InputForm
							name="cvv"
							id="cvv"
							type="tel"
							value={cvv}
							onChange={this.onChange}
							label="CVV"
							errorMessage="Código inválido"
							maxLength={details ? details.code.size : 4}
							hasError={errors.cvv}
							data-action="register-credit-card-security-code"
						/>
					</div>
					<div className="col-xs-16 col-md-12">
						<InputForm
							name="holderName"
							id="holderName"
							value={holderName}
							onChange={this.onChange}
							label="Nome (como está no cartão)"
							errorMessage="Este nome não é o mesmo do cartão"
							maxLength={150}
							hasError={errors.holderName}
							data-action="register-credit-card-name"
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-16 col-md-8">
						<InputForm
							name="cardCpf"
							id="cardCpf"
							label="CPF do titular do cartão"
							value={cardCpf}
							disabled
							data-action="register-credit-card-cpfcnpj"
						/>
					</div>
				</div>
			</div>
		);
	}
}

EditCreditCardDetails.propTypes = {
	creditCardData: PropTypes.object.isRequired,
	checkData: PropTypes.func,
	setData: PropTypes.func
};

export default EditCreditCardDetails;
